import axios from 'axios'
import { createAsyncThunk } from '@reduxjs/toolkit'
import EmployeeConfig from '../../../services/api/EmployeeConfig'

const { Attachment_Endpoints } = EmployeeConfig
const SELF_BFF_API = process.env.REACT_APP_SELF_BFF_BASE_URL

export const attachmentResetAlertHandler = createAsyncThunk(
  'attachment/attachmentResetAlertHandler',
  async () => ({}),
)

export const attachmentCreateGroup = createAsyncThunk(
  'attachment/attachmentCreateGroup',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Attachment_Endpoints()
    const response = await axios.post(`${SELF_BFF_API}/${apiUri.createGroup}`, queries)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const attachmentGetGroupAttachmentsByGroupIds = createAsyncThunk(
  'attachment/attachmentGetGroupAttachmentsByGroupIds',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Attachment_Endpoints()
    const response = await axios.get(`${SELF_BFF_API}/${apiUri.getGroupAttachmentsByGroupIds}`, {
      params: queries,
    })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const attachmentAddAttachmentToGroup = createAsyncThunk(
  'attachment/attachmentAddAttachmentToGroup',
  async ({ queries, groupId }, { rejectWithValue }) => {
    const apiUri = Attachment_Endpoints(groupId)

    const response = await axios.post(`${SELF_BFF_API}/${apiUri.addAttachmentToGroup}`, queries, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const attachmentDeleteSingleAttachment = createAsyncThunk(
  'attachment/attachmentDeleteSingleAttachment',
  async (queries, { rejectWithValue }) => {
    const apiUri = Attachment_Endpoints(queries?.groupId, queries?.attachmentId)
    const response = await axios.delete(`${SELF_BFF_API}/${apiUri.deleteSingleAttachment}`)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)

export const downloadAttachmentById = createAsyncThunk(
  'attachment/downloadAttachmentById',
  async ({ queries }, { rejectWithValue }) => {
    const apiUri = Attachment_Endpoints(queries?.groupId, queries?.attachmentId)
    const response = await axios.get(`${SELF_BFF_API}/${apiUri.downloadAttachmentById}`, { responseType: 'blob' })

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    if (response.data) {
      const blob = new Blob([response.data], { type: response.headers['content-type'] })
      const url = window.URL.createObjectURL(blob)

      const a = document.createElement('a')
      a.href = url
      a.download = queries?.name
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }
    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return response.data
  },
)
